import React, { useEffect, useState } from 'react';

const isBlankImage = (img) => {
  try {
    const canvas = document.createElement('canvas');
    const size = 12;
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return false;
    ctx.drawImage(img, 0, 0, size, size);
    const pixels = ctx.getImageData(0, 0, size, size).data;
    let visible = 0;
    let nonWhite = 0;
    let redBrandLike = 0;
    for (let i = 0; i < pixels.length; i += 4) {
      const alpha = pixels[i + 3];
      if (alpha < 12) continue;
      visible += 1;
      const red = pixels[i];
      const green = pixels[i + 1];
      const blue = pixels[i + 2];
      if (pixels[i] < 246 || pixels[i + 1] < 246 || pixels[i + 2] < 246) {
        nonWhite += 1;
      }
      if (red > 135 && red > green * 1.45 && red > blue * 1.45) {
        redBrandLike += 1;
      }
    }
    if (visible / (size * size) < 0.04) return true;
    if (visible > 0 && redBrandLike / visible > 0.58) return true;
    return visible > 0 && nonWhite / visible < 0.04;
  } catch (_err) {
    return false;
  }
};

export const SafeAvatarImage = ({ src, alt, fallback, style, imageStyle, dataTestId }) => {
  const [hidden, setHidden] = useState(!src);

  useEffect(() => {
    setHidden(!src);
  }, [src]);

  if (!src || hidden) return fallback;

  return (
    <img
      src={src}
      alt={alt}
      data-testid={dataTestId}
      onError={() => setHidden(true)}
      onLoad={(event) => {
        if (isBlankImage(event.currentTarget)) setHidden(true);
      }}
      style={{ width: '100%', height: '100%', objectFit: 'cover', ...style, ...imageStyle }}
    />
  );
};

export default SafeAvatarImage;